var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 2 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "International") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_21-30",
    "data-name": "21-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Global"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.015,14.015,0,0,0,16,2Zm0,26c-1.253,0-2.879-2.573-3.611-7h7.223C18.879,25.427,17.253,28,16,28Zm-3.861-9c-.087-.941-.139-1.937-.139-3s.052-2.059.139-3h7.722c.087.941.139,1.937.139,3s-.052,2.059-.139,3ZM4,16a11.926,11.926,0,0,1,.395-3h5.746c-.09.994-.141,2-.141,3s.051,2.006.141,3H4.395A11.926,11.926,0,0,1,4,16ZM16,4c1.253,0,2.879,2.573,3.612,7H12.389C13.121,6.573,14.747,4,16,4Zm5.859,9h5.746a11.59,11.59,0,0,1,0,6H21.859c.09-.994.141-2,.141-3S21.949,13.994,21.859,13ZM26.9,11H21.618a18.664,18.664,0,0,0-2.075-6.465A12.048,12.048,0,0,1,26.9,11ZM12.457,4.535A18.664,18.664,0,0,0,10.382,11H5.105A12.048,12.048,0,0,1,12.457,4.535ZM5.105,21h5.277a18.664,18.664,0,0,0,2.075,6.465A12.048,12.048,0,0,1,5.105,21Zm14.438,6.465A18.664,18.664,0,0,0,21.618,21H26.9A12.048,12.048,0,0,1,19.543,27.465Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.e61d9ec2408999d4ec31e608c9bd69b4.svg";
export { ForwardRef as ReactComponent };